/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {SwitchButtonConfiguration} from '../../../../shared/switch-button/configuration/switch-button.configuration';
import {
    ConfirmModalConfigurationModel
} from '../../../../shared/confirm-modal/confirm-modal/models/confirm-modal-configuration.model';
import {AlertNotificationSeverity} from '../../../../alert-notification-severity.model';


const alertsConfigCreateNewConfiguration: {
    statusAlertConfigSwitchButtonConfiguration: SwitchButtonConfiguration;
    scheduleAlertConfigSwitchButtonConfiguration: SwitchButtonConfiguration;
    timeZoneTooltipInfo: string;
    timeZone: string;
    applyNewAlertsConfig: ConfirmModalConfigurationModel;
    editAlertsConfig: ConfirmModalConfigurationModel;
    discardNewAlertsConfig: ConfirmModalConfigurationModel;
} = {
    statusAlertConfigSwitchButtonConfiguration: {
        spaceInBetween: 10,
        labelOnRight: true,
        label: 'Alert message activation',
        labelBold: true,
        tooltipText: 'If activated without any specific period defined, the alert will start immediately'
    },
    scheduleAlertConfigSwitchButtonConfiguration: {
        spaceInBetween: 10,
        labelOnRight: true,
        label: 'Alert message for a specific period',
        labelBold: true,
        tooltipText: 'Activate to schedule alert on specific period.'
    },
    timeZoneTooltipInfo: 'TIME ZONE - The time zone applied is UTC 00:00',
    applyNewAlertsConfig: {
        title: 'Alert creation confirmation',
        primaryActionTitle: 'Apply',
        secondaryActionTitle: 'Discard',
        alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
        body: {
            title: 'Do you want to save the new Alert message?'
        }
    },
    editAlertsConfig: {
        title: 'Alert edit confirmation',
        primaryActionTitle: 'Apply',
        secondaryActionTitle: 'Discard',
        alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
        body: {
        }
    },
    discardNewAlertsConfig: {
        title: 'Confirm',
        primaryActionTitle: 'Keep editing',
        secondaryActionTitle: 'Discard changes',
        alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
        body: {
            title: 'The changes you performed will not be saved, are you sure you want to proceed?'
        }
    },
    timeZone: 'Etc/UTC'

};

export default alertsConfigCreateNewConfiguration;
